import React, { useState } from "react";
import { exportToExcel } from "../../utils/ExportExcel";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { exportToCSV } from "../../utils/ExportCSV";
import { exportToPDF } from "../../utils/ExportPDF";

const ExportDialogBox = ({ handleCancel, data, fileName, onExport, getComputedExportData }) => {
  const [selectedFormat, setSelectedFormat] = useState(null);
  const [isExporting, setIsExporting] = useState(false);

  const exportFormats = [
    { id: "pdf", label: "PDF" },
    { id: "excel", label: "Excel" },
    { id: "csv", label: "CSV" },
  ];

  const handleFormatSelect = (format) => {
    setSelectedFormat(format);
  };
  const handleExportExcel =(data, fileName)=>{
    exportToExcel(data, fileName);
  }
  const handleExportPDF =(data, fileName)=>{
    exportToPDF(data, fileName);
  }
  const handleExportCSV =(data, fileName)=>{
    console.log("csv");
    exportToCSV(data, fileName);
  }

  const handleConfirmExport = async () => {
    if (!selectedFormat) {
      toast.error("Please select a format");
      return;
    }

    setIsExporting(true);
    
    try {
      let exportData = data;
      
      // If onExport function is provided, fetch all data
      if (onExport && getComputedExportData) {
        toast.info("Fetching all records for export... This may take a moment.");
        const allData = await onExport();
        exportData = getComputedExportData(allData);
      }
      
      if (selectedFormat === "excel") {
        handleExportExcel(exportData, fileName);
        toast.success("Excel export completed successfully!");
      } else if (selectedFormat === "pdf") {
        handleExportPDF(exportData, fileName);
        toast.success("PDF export completed successfully!");
      } else if (selectedFormat === "csv") {
        handleExportCSV(exportData, fileName);
        toast.success("CSV export completed successfully!");
      } else {
        toast.error("Incorrect Format");
      }
      
      // Close the dialog after successful export
      handleCancel();
    } catch (error) {
      console.error("Export failed:", error);
      toast.error("Export failed. Please try again.");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-3xl w-[80vw] lg:w-[50vw]  shadow-xl">
        <div className="text-left">
          <h3 className="text-2xl font-bold mb-3 text-text1">Export</h3>
          <p className="text-text3 text-sm font-normal mb-2">
            Select the file format that you would like to export.
          </p>
          <p className="text-orange-600 text-xs font-normal mb-4">
            Note: All records matching your filters will be exported. This may take a few moments for large datasets.
          </p>
          <hr className="border-t border-gray-200 mb-6" />
        </div>

        <div className="grid grid-cols-1  sm:grid-cols-3 gap-4 mb-6">
          {exportFormats.map((format) => (
            <div
              key={format.id}
              className={`
                cursor-pointer 
                border-2 
                rounded-lg 
                p-4 
               flex
                items-center 
                transition-all 
                duration-300
                ${
                  selectedFormat === format.id
                    ? "border-primary bg-white"
                    : "border-gray-200"
                }
              `}
              onClick={() => handleFormatSelect(format.id)}
            >
              <div
                className={`
                  w-5 h-5 
                  rounded-full 
                  mr-3 
                  flex 
                  items-center 
                  justify-center
                  ${
                    selectedFormat === format.id
                      ? "bg-primary border-primary"
                      : "border-gray-300 bg-gray-200 "
                  }
                `}
              >
                {selectedFormat === format.id ? (
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                ) : (
                  <div className="w-2 h-2 bg-white border-1  rounded-full"></div>
                )}
              </div>
              <span
                className={`
                font-medium 
                ${
                  selectedFormat === format.id ? "text-secondary" : "text-text1"
                }
              `}
              >
                {format.label}
              </span>
            </div>
          ))}
        </div>

        <div className="flex justify-end gap-3">
          <button
            className="
              border 
              border-gray-300 
              px-4 
              py-2 
              rounded-md 
              text-gray-700 
              hover:bg-gray-50 
              transition-colors
            "
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button
            className={`
              px-4 
              py-2 
              rounded-md 
              text-white 
              transition-all 
              duration-300
              flex
              items-center
              gap-2
              ${
                selectedFormat && !isExporting
                  ? "bg-primary hover:bg-primary-dark"
                  : "bg-gray-400 cursor-not-allowed"
              }
            `}
            onClick={handleConfirmExport}
            disabled={!selectedFormat || isExporting}
          >
            {isExporting ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                Exporting...
              </>
            ) : (
              "Export"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExportDialogBox;
